<template>
  <div class="kpb-slider">
    <slot name="top" />
    <Slider
      class="kpb-slider__slider"
      v-if="data.length"
      :value="data"
      v-bind="optionsComp"
      :style="`--kpb-slider-aspect-ratio: ${aspectRatio}; --kpb-slider-background-color: ${backgroundColor}`"
    >
      <template #overlay>
        <slot name="default" />
      </template>
    </Slider>

    <slot name="bottom" />
  </div>
</template>
<script>
import Slider from '@kvass/media-render/Slider'
/** Slider component (supports : image, vimeo, youtube) */

const defaultOptions = {
  manualNavigation: true,
  displayThumbnail: true,
}

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    metaInfo: {
      type: Object,
      default: () => {},
    },
    aspectRatio: {
      type: String,
      default: '16/9',
    },
    backgroundColor: {
      type: String,
      default: '#fafafa',
    },
  },
  computed: {
    optionsComp() {
      return {
        ...defaultOptions,
        ...this.options,
      }
    },
  },
  components: {
    Slider,
  },
}
</script>

<style lang="scss">
.kpb-slider {
  width: 100%;
  &__slider {
    aspect-ratio: var(--kpb-slider-aspect-ratio);
    background-color: var(--kpb-slider-background-color);
  }
}
</style>
